import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:3000/api', // Set your API base URL here if needed
})

// Add a request interceptor to insert the Authorization token if it exists
api.interceptors.request.use(
  config => {
    // Try to get the token from localStorage (or sessionStorage, or any other storage as needed)
    const token = import.meta.env.VITE_STATIC_TOKEN
    if (token) {
      config.headers = config.headers || {}
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

export default api
